"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = exports.getFloatValue = exports.getExactLocale = exports.LANG = void 0;
/**
 * @ignore
 */
exports.LANG = {
    EN: 'en',
    FR: 'fr',
    EN_CA: 'en-CA',
    FR_CA: 'fr-CA',
};
/**
 * @ignore
 */
const setCharAt = (str, index, chr) => {
    if (index > str.length - 1)
        return str;
    return str.substr(0, index) + chr + str.substr(index + 1);
};
/**
 * @ignore
 */
const getExactLocale = (locale) => {
    return locale === exports.LANG.FR || locale === exports.LANG.FR_CA ? exports.LANG.FR_CA : exports.LANG.EN_CA;
};
exports.getExactLocale = getExactLocale;
/**
 * @ignore
 */
const getFloatValue = (balance, fractionDigits, locale) => {
    let strValue = balance;
    strValue = strValue.replace(/ /g, '');
    const lastIndexOfComa = strValue.lastIndexOf(',');
    if (lastIndexOfComa !== -1 &&
        (strValue.length - lastIndexOfComa <= fractionDigits + 1 ||
            (locale === 'fr' && fractionDigits < 2))) {
        strValue = setCharAt(strValue, lastIndexOfComa, '.');
    }
    strValue = strValue.replace(/[,]/g, '');
    const separatorIndex = strValue.indexOf('.');
    if (separatorIndex !== -1) {
        strValue = strValue.substring(0, separatorIndex + fractionDigits + 1);
    }
    const floatValue = Number.parseFloat(strValue);
    return floatValue;
};
exports.getFloatValue = getFloatValue;
/**
 * @ignore
 */
const format = (balance, locale, fractionDigits, currency, hideSymbol, currencyDisplay = false) => {
    const exactLocale = (0, exports.getExactLocale)(locale);
    const formatter = new Intl.NumberFormat(exactLocale, {
        style: 'currency',
        minimumIntegerDigits: 1,
        minimumFractionDigits: fractionDigits,
        currency,
    });
    const floatValue = (0, exports.getFloatValue)(balance, fractionDigits, locale);
    let formatedValue = isNaN(floatValue) ? '' : formatter.format(floatValue);
    formatedValue = hideSymbol
        ? formatedValue.replace('$', '').replace('€', '').replace(' ', '')
        : formatedValue;
    if (exactLocale === exports.LANG.FR_CA && currency === 'CAD') {
        formatedValue = formatedValue.replace('CA', '');
    }
    else if (currency === 'USD') {
        formatedValue = formatedValue.replace('US', '');
    }
    formatedValue = formatedValue.trim();
    if (currencyDisplay && exactLocale === exports.LANG.FR_CA) {
        formatedValue = `${formatedValue} ${currency}`;
    }
    else if (currencyDisplay && exactLocale === exports.LANG.EN_CA) {
        formatedValue = `${currency} ${formatedValue}`;
    }
    return formatedValue;
};
exports.format = format;
//# sourceMappingURL=utils.js.map